import { render, staticRenderFns } from "./ModalInserirNovoReajuste.vue?vue&type=template&id=63d0a782&scoped=true"
import script from "./ModalInserirNovoReajuste.vue?vue&type=script&lang=js"
export * from "./ModalInserirNovoReajuste.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d0a782",
  null
  
)

export default component.exports